import { render, staticRenderFns } from "./catalog-item-hover-slider-mobile.vue?vue&type=template&id=434d841e&scoped=true&"
import script from "./catalog-item-hover-slider-mobile.vue?vue&type=script&lang=js&"
export * from "./catalog-item-hover-slider-mobile.vue?vue&type=script&lang=js&"
import style0 from "./catalog-item-hover-slider-mobile.vue?vue&type=style&index=0&id=434d841e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "434d841e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PictureComponent: require('/var/www/components/picture/picture-component.vue').default,ButtonFavorite: require('/var/www/components/button/button-favorite.vue').default})
